import { IssueCommentAttachmentService as OvermapIssueCommentAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueCommentAttachmentService extends OvermapIssueCommentAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
